import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PensionsService {

  constructor(private http: HttpClient) {}

  getPensionsData(formsId: number): Observable<any> {
    return this.http.get(`${environment.api_guia}forms/${formsId}/pensions`);
  }

  updatePensionsData(formsId: number, pensionsId: number, data: any): Observable<any> {
    return this.http.patch(`${environment.api_guia}forms/${formsId}/pensions/${pensionsId}`, data);
  }
}
